export const MONTH_SCHEDULING_LABELS = {
	daysOfMonthToRunScan: 'Select days',
	startTime: 'Start time',
	timezone: 'Time zone',
	startMonth: 'Start month',
	lastDayOfMonth: 'Last day of month',
	monthlySelectionWarning:
		'If the scheduled day doesn’t occur in a month, the scan runs on the last day of that month.'
};
